export default "__VITE_ASSET__DkA4gSmi__"